export const Mutations = {
  SET_USER: "set-user",
  START_LOADING: "start-loading",
  RELEASE_LOADING: "release-loading",
  SET_LIST: "set-list",
  SELECT_SITE: "select-site",
  SELECT_SERVICE: "select-service",
  SET_SITE: "set-site",
  SET_DRAWER: "set-drawer",
  SELECT_DATE: "sel-date",
  SELECT_PRODUCT_ID: "sel-pduct-id",
  SELECT_DB_PRODUCT_ID: "sel-db-pduct-id",
  SELECT_MEDIA_ID: "sel-media-id",
  FORM_DIALOG: "form-dialog",
  FORM_DIALOG_DB: "form-dialog-db",
  FORM_DIALOG_MOVE: "form-dialog-move",
  FORM_DIALOG_DUPLICATE: "form-dialog-duplicate",
  FORM_DIALOG_MEDIA: "form-dialog-media",
  SET_ARTICLES: "set-articles",
  SET_MENUS: "set-menus",
  SET_CURRENT_MENU: "set-current-menu",
  SET_ZONE: "set-zone",
  SET_BOOKINGS: "set-bookings",
  SET_BOOKING_CONFIGURATION: "set-booking-configuration",
  SET_BOOKING_STATISTICS: "set-booking-statistics",
  UPDATE_BOOKING_STATISTICS: "update-booking-statistics",
  SET_DB_PRODUCTS: "set-dbProducts",
  SET_MEDIAS: "set-medias",
  SET_ENABLE_I18N: "set-enableI18n",
  SET_BALANCE_ALERT_CONFIGURATION: "set-balance-alert-configuration",
};
